// Market reference data for P2P fee-rate scoping. There is no backend list
// endpoint for fiat/crypto/countries, so these mirror the user-facing P2P app
// (frontend/src/components/P2PTrading.tsx). Keep them in sync when that list
// changes. Codes are upper-cased to match server-side normalization.

export interface Option {
  value: string;
  label: string;
}

export const FIAT_CURRENCIES: Option[] = [
  { value: 'USD', label: 'USD - US Dollar' },
  { value: 'INR', label: 'INR - Indian Rupee' },
];

export const CRYPTO_CURRENCIES: Option[] = [
  { value: 'USDT', label: 'USDT - Tether' },
  { value: 'BTC', label: 'BTC - Bitcoin' },
  { value: 'ETH', label: 'ETH - Ethereum' },
  { value: 'USDC', label: 'USDC - USD Coin' },
  { value: 'BNB', label: 'BNB - BNB' },
  { value: 'TRX', label: 'TRX - TRON' },
];

// Fee currency can be either fiat or crypto.
export const FEE_CURRENCIES: Option[] = [...CRYPTO_CURRENCIES, ...FIAT_CURRENCIES];

export const COUNTRIES: Option[] = [
  { value: 'US', label: 'US - United States' },
  { value: 'GB', label: 'GB - United Kingdom' },
  { value: 'DE', label: 'DE - Germany' },
  { value: 'FR', label: 'FR - France' },
  { value: 'RU', label: 'RU - Russia' },
  { value: 'UA', label: 'UA - Ukraine' },
  { value: 'KZ', label: 'KZ - Kazakhstan' },
  { value: 'UZ', label: 'UZ - Uzbekistan' },
  { value: 'TR', label: 'TR - Turkey' },
  { value: 'AE', label: 'AE - UAE' },
  { value: 'CN', label: 'CN - China' },
  { value: 'IN', label: 'IN - India' },
  { value: 'ID', label: 'ID - Indonesia' },
  { value: 'BR', label: 'BR - Brazil' },
  { value: 'MX', label: 'MX - Mexico' },
  { value: 'CA', label: 'CA - Canada' },
  { value: 'AU', label: 'AU - Australia' },
  { value: 'NG', label: 'NG - Nigeria' },
  { value: 'PK', label: 'PK - Pakistan' },
];
